import React from 'react';
import { Box, Heading, ScrollView } from '@gluestack-ui/themed';

export const AdminWidget = ({
  title, w, h, children,
}) => (
  <Box
    bg="transparent"
    mx={w ? 0 : '$6'}
    px={w ? '$6' : 0}
    mb="$4"
    w={w}
    h={h}
    maxHeight="97%"
    overflow="hidden"
  >
    {!!title && (
      <Heading mt="$4" mx="$4">
        {title}
      </Heading>
    )}
    <ScrollView>
      {children}
    </ScrollView>
  </Box>
);

export default AdminWidget;
